import { ApplicationAddressScreen } from "@/interactors/ApplicationAddressScreen";

export default function Address() {
  return <ApplicationAddressScreen />;
}
